import { AnyObject } from '@store/types';
import type {
    IndividualReport,
    IndividualReportCreationParams,
    IndividualReportUpdatingParams,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/individual-report';

export class IndividualReportsApi {
    public static async getReports(legalEntityId: string): Promise<IndividualReport[]> {
        const res = await axios.get(`${BASE_URL}/`, { params: { legalEntityId } });

        return res.data.individualReports;
    }

    public static async create(individualReport: IndividualReportCreationParams): Promise<void> {
        await axios.post(`${BASE_URL}/`, { individualReport });
    }

    public static async update(
        individualReportId: string,
        individualReport: IndividualReportUpdatingParams,
    ): Promise<void> {
        await axios.put(`${BASE_URL}/${individualReportId}`, { individualReport });
    }

    public static async renderReport(individualReportId: string, data: AnyObject): Promise<Blob> {
        const res = await axios.post(
            `${BASE_URL}/report`,
            { data, id: individualReportId },
            { responseType: 'blob', timeout: 0 },
        );
        return res.data;
    }
}
